﻿import { BaseEditor } from './base-editor';
import { IForm } from '../interface/form';
import { AsyncValidatorFn, ValidatorFn } from '../types/validator-fn';
import { IEditor } from '../interface/editor';

export const SelectEditorTagName = 't-select';

export function createSelectEditor(form: IForm,
  name: string,
  element: HTMLElement,
  validators: ValidatorFn[],
  asyncValidators: AsyncValidatorFn[]): IEditor {
  return new TSelectEditor(form, name, element, validators, asyncValidators);
}

export class TSelectEditor extends BaseEditor<string | string[]> {
  selectElement: HTMLSelectElement = null!;

  constructor(
    form: IForm,
    name: string,
    element: HTMLElement,
    validators: ValidatorFn[],
    asyncValidators: AsyncValidatorFn[]) {
    super(form, name, element, validators, asyncValidators);

    const ele = element.querySelector<HTMLSelectElement>('select.form-select');
    if (!ele) {
      throw new Error(`Invalid DOM of field ${name}`);
    }

    this.selectElement = ele;
    this.selectElement.addEventListener('change', (ev: Event) => {
      this.reValidate();
      this.notifyChanges(this.value);
    });

  }

  get value(): string | string[] {
    const selectedValues = [...this.selectElement.selectedOptions]
      .map(option => option.value);
    if (this.selectElement.multiple) {
      return selectedValues;
    }
    else {
      if (selectedValues.length === 0) {
        return '';
      } else {
        return selectedValues[0];
      }
    }
  }

  set value(value: string | string[]) {
    const selectOptions = this.selectElement.options;
    for (let i = 0; i < selectOptions.length; i++) {
      if (Array.isArray(value)) {
        if (value.indexOf(selectOptions[i].value) >= 0) {
          selectOptions[i].selected = true;
        } else {
          selectOptions[i].selected = false;
        }
      }
      else if (String(value) === String(selectOptions[i].value)) {
        selectOptions[i].selected = true;
      } else {
        selectOptions[i].selected = false;
      }
    }
  }

  setDisabled(disabled: boolean): void {
    this.selectElement.disabled = disabled;
    this.setDisabledInternal(disabled);
  }

  setFocus(): void {
    this.selectElement.focus();
  }
}
